import { render, staticRenderFns } from "./TicketTypes.vue?vue&type=template&id=2c225dd2&"
import script from "./TicketTypes.vue?vue&type=script&lang=js&"
export * from "./TicketTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports